export enum EmassarMethod {
    Estate = 'getEstates',
    Tenant = 'getTenantsData'
}